import { title } from "framer-motion/client";

export const zh = {
  translation: {
    nav: {
      title: '针灸养生馆',
      home: '主页',
      services: '服务项目',
      about: '关于我们',
      contact: '联系我们',
      gallery: '画廊',
      appointment: '预约',
      herbtea: '中药茶',
      telemedicine: "远程医疗",
      store: "商店"
    },
    home: {
      welcome: '针灸养生馆',
      subtitle: '传承与创新，治愈与关怀',
      description1: '在现代医学与传统中医的完美结合下，体验针灸的独特疗效。',
      description2: '我们承载着三代传承的精髓，结合现代医学理念，为每一位患者提供专业的诊疗服务。',
      description3: '我们的针灸师团队不仅精通传统的针灸、拔罐、刮痧和中药治疗，还研发了独创的针灸治疗方法，成功解决了诸如面瘫、腰椎间盘突出、坐骨神经痛、颈椎压迫疼痛等多种疑难杂症。我们致力于为您提供个性化、专业化的治疗方案，帮助您恢复身体的平衡与活力。',
      description4: '在这里，您不仅能找到传统中医的深厚底蕴，还能体验到前沿医学理念带来的治疗效果。让我们帮助您恢复健康，焕发新生！ ‌——循天时·通地脉·养人命',
      subtitleinsurance: '想知道您的保险是否涵盖针灸吗？', // Add subtitle for insurance prompt
      insuranceprompt: '请将您的问题发短信至408-922-6848，或通过电子邮件发送至zenlifeacu@gmail.com。请提供您的姓名、电话号码、出生日期以及保险卡的正反面照片。',
      contactButton: '联系我们',
      bookButton: '预约',
      promotions: '促销和公告',
      videoTitle: "神秘特饮盲盒",
      videoDescription: "每周日免费推出一款中医隐藏款特饮，仅限当天尝鲜"
    },
    services: {
      title: '我们的服务',
      acupuncture: {
        title: '针灸',
        description: '治疗肩痛、头痛、坐骨神经痛、过敏、除皱、减重、失眠等。'
      },
      electroacupuncture: {
        title: '电针',
        description: '慢性疼痛, 神经系统疾病, 运动损伤恢复, 情绪问题, 消化系统问题, 妇科问题'
      },
      cupping: {
        title: '拔罐',
        description: '缓解疼痛、祛湿、治疗坐骨神经痛、排毒等。'
      },
      guaSha: {
        title: '刮痧',
        description: '治疗月经痛、腰痛、膝痛，增强免疫系统。'
      },
      manualTherapy: {
        title: '推拿按摩',
        description: '手法治疗技术，缓解疼痛，促进愈合。'
      },
      infraLight: {
        title: '红外线治疗',
        description: '先进的光疗技术，增强治疗效果，缓解疼痛。'
      },
      herbs: {
        title: '中药',
        description: '根据个人需求定制的传统草药治疗。'
      }
    },
    contact: {
      title: '联系我们',
      direction: '位置导航',
      address: {
        title: '地址',
        value: '8 N Abel St, Milpitas, CA 95035'
      },
      phone: {
        title: '电话',
        regularHours: '营业时间: 408-922-6848',
        afterHours: '非营业时间: 408-465-4289'
      },
      email: {
        title: '电子邮件',
        value: 'zenlifeacu@gmail.com'
      },
      payment: {
        title: '支付方式',
        description: '我们接受所有主要PPO保险、信用卡、HSA、PayPal、Venmo'
      },
      findUs: '我们位于米尔皮塔斯市中心，靠近880和680高速。',
      specializedClaims: "专业保险理赔",
      carAccidentClaims: "我们接受车祸保险索赔，并直接与汽车保险公司合作提供必要的治疗文档。",
      workersCompClaims: "我们处理工伤赔偿申请，帮助患者康复并重返工作岗位。",
      legalReferrals: "我们欢迎专门从事人身伤害和工伤赔偿案件的律师事务所转介患者。"
    },
    // Add to existing zh.js translation object
    footer: {
      title: '针灸养生馆',
      address: '8 N Abel St\nMilpitas, CA 95035',
      contact: {
        title: '联系方式',
        phone: '电话：408-922-6848',
        email: '邮箱：zenlifeacu@gmail.com'
      },
      social: {
        title: '关注我们',
        wechat: '微信：ZenLifeAcupuncture',
        rednote: '小红书：ZenLifeAcu'
      },
      copyright: '针灸养生馆。版权所有。'
    },
    // ... existing code ...
    telemedicine: {
      title: "远程医疗服务",
      subtitle: "在家中舒适地与我们经验丰富的针灸师进行虚拟咨询",
      benefitsTitle: "我们远程医疗服务的优势",
      payWithPayPal: "使用PayPal付款", // Chinese
      benefits: {
        benefit1: "无需离家即可便捷获取专业中医咨询",
        benefit2: "根据您的特定健康需求提供个性化草药处方",
        benefit3: "详细的健康评估和定制治疗计划",
        benefit4: "根据需要提供后续护理和治疗调整",
        benefit5: "节省时间并避免出行，同时获得专业护理",
        benefit6: "获取我们关于传统中医和草药疗法的丰富知识"
      },
      processTitle: "我们的远程医疗服务如何运作",
      process: {
        step1: {
          title: "1. 付款",
          description: "使用下方的PayPal按钮为您的30分钟远程医疗咨询付款。"
        },
        step2: {
          title: "2. 预约",
          description: "付款后，使用您的订单号在线预约。您可以上传您的病历和任何相关的实验室结果。"
        },
        step3: {
          title: "3. 虚拟咨询",
          description: "通过Zoom与我们的持证针灸师会面，讨论您的健康状况。我们将提供全面评估，必要时提供草药处方和健康建议。"
        },
        step4: {
          title: "4. 草药付款（如需要）",
          description: "如果建议使用草药，我们将向您发送草药和运费的账单。可以在线支付。"
        },
        step5: {
          title: "5. 接收草药",
          description: "我们将准备并直接将您的定制草药配方运送到您家中。"
        }
      },
      paymentTitle: "预约您的远程医疗咨询",
      consultationFee: "30分钟咨询：$50",
      afterPayment: "付款后，您将收到一封带有订单号的确认电子邮件。使用此号码安排您的预约。",
      scheduleButton: "安排预约",
      herbsTitle: "关于我们的草药",
      herbsDescription: "我们的草药处方根据您的特定健康需求定制。我们只使用经过纯度和效力测试的高质量、正宗的中草药。",
      shippingInfo: "草药成本和运费根据处方、您的位置和运输方式而有所不同。我们提供各种运输方法以满足您的需求和预算。"
    },
    store: {
      title: "Zen Life 在线商店",
      subtitle: "传统中医产品",
      description: "浏览我们精选的高品质传统中医产品，全国范围内均可配送。",
      buyNow: "立即购买",
      products: [
        {
          name: "100%纯天然本草止痒膏",
          price: "$39.99",
          description: "缓解因湿疹或特应性皮炎引起的瘙痒、干燥、脱屑。仅限外用。",
          image: "/images/products/product1.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/USDMG75T3T7CW"
        },
        {
          name: "多种健康调理草本茶",
          price: "$80",
          description: "专为各种健康状况精心配制的手工草本茶。每包优质茶包提供全天的治疗茶饮，可冲泡高达1加仑水，发挥最大功效。我们精心挑选的草本植物全天候为您提供天然健康支持。",
          image: "/images/products/product2.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/FGWQPWEAVZ9AL"
        }
        // More products can be added here later
      ]
    },
    // ... existing code ...
    herbtea: {
      title: "🌿 中医养生茶 · 湾区工程师专属定制 🌿",
      subtitle: "☕ 忙碌中也要养生 —— 你的身心调养，我们来守护！",
      description: "我们以纯天然中药材为基础，结合中医理论，精心调配出适合湾区工程师人群的多款养生茶饮。根据不同体质与需求，您可以灵活选择适合自己的茶饮疗程：",
      benefits: [
        "✔ 剂量科学配比，无需熬药",
        "✔ 茶包即泡即饮，简单方便",
        "✔ 三周一个疗程，每周三杯即可",
        "✔ 欢迎来店免费试饮！"
      ],
      benefits1: "功效",
      ingredients: "成分",
      customService: {
        title: "🧑‍⚕️ 个性化定制服务 · 针对您的身体调理",
        description: "我们提供一对一中医体质分析与定制茶饮服务，为您量身打造专属养生方案：",
        options: [
          {
            name: "保健型个性化茶饮",
            details: "诊疗 + 一个疗程养生茶饮",
            price: "仅需 $80"
          },
          {
            name: "治疗型中药服务",
            details: "诊疗 + 一个疗程浓缩型中药汤剂（针对具体症状调理）",
            price: "$200"
          }
        ]
      },
      popularTeas: {
        title: "🍵 五款热销养生茶饮推荐",
        teas: [
          {
            id: 1,
            name: "金银花茶",
            ingredients: "黄芪、金银花、辛夷花、菊花",
            benefits: "增强免疫，缓解鼻敏感、花粉过敏"
          },
          {
            id: 2,
            name: "养心安神饮",
            ingredients: "丹参、百合、酸枣仁、石菖蒲",
            benefits: "改善睡眠质量，助眠安神"
          },
          {
            id: 3,
            name: "参苓白术饮",
            ingredients: "陈皮、白术、茯苓、薏苡仁、金钱草、佛手",
            benefits: "健脾祛湿，调理肠胃"
          },
          {
            id: 4,
            name: "安神益智茶",
            ingredients: "益智仁、枸杞、丹参、石菖蒲",
            benefits: "改善脑部循环，提神醒脑"
          },
          {
            id: 5,
            name: "美人养颜茶",
            ingredients: "黄芪、丹参、当归、枸杞、玫瑰花",
            benefits: "补气养血，美肤养颜"
          }
        ]
      },
      pricing: {
        title: "💰 价格优惠 · 灵活选择",
        options: [
          "三杯体验装：$15",
          "六杯基础装：$26",
          "九杯疗程装：$40",
          "保健型定制（诊疗+茶饮）：$80",
          "治疗型浓缩中药（诊疗+汤剂）：$200"
        ],
        promotion: "🎁 来店即享免费试饮，开启属于你的专属养生之旅！"
      }
    }
  },
  electroAcupunture:
  {
    "header": "电针针灸及其功效",
    "section1_title": "电针针灸基本概念",
    "section1_text": "电针针灸是一种结合了传统针灸和现代电疗技术的治疗方法，通过在针灸的基础上施加微弱的电流，来刺激身体的特定穴位。它被广泛应用于疼痛管理、神经系统疾病、肌肉和关节病症的治疗，以及改善身体的整体健康。",

    "section2_title": "电针针灸的主要功效",
    "benefit1": "缓解疼痛：电针针灸通过刺激神经系统，调节疼痛信号的传递，能够有效缓解慢性疼痛和急性疼痛，常用于治疗例如关节炎、头痛、肩膀痛等症状。",
    "benefit2": "改善血液循环：电流刺激能够促进局部血液循环，帮助改善组织的氧气和营养供应，促进新陈代谢，减少炎症反应。",
    "benefit3": "调节神经系统：电针能够刺激自律神经系统，调节体内的神经活动，有助于缓解焦虑、失眠等情绪问题，增强免疫力。",
    "benefit4": "缓解肌肉痉挛和放松肌肉：电流能够有效放松紧张的肌肉，改善肌肉的弹性和舒展度，对肌肉痉挛和僵硬有显著的缓解作用。",
    "benefit5": "促进组织修复与恢复：电针有助于加速受伤组织的修复过程，促进细胞的再生和修复，常用于运动损伤后的康复治疗。",
    "benefit6": "增强免疫力：电针能够调节体内的免疫反应，提高身体对外界病原的抵抗力，对于一些免疫系统相关的疾病，如过敏、慢性疾病等，具有辅助治疗作用。",

    "section3_title": "电针针灸的适应症",
    "indication1": "慢性疼痛（如关节炎、背痛、颈痛）",
    "indication2": "神经系统疾病（如中风后的康复、面瘫）",
    "indication3": "运动损伤恢复（如肌肉拉伤、韧带损伤）",
    "indication4": "情绪问题（如失眠、焦虑）",
    "indication5": "消化系统问题（如便秘、腹泻）",
    "indication6": "妇科问题（如月经不调、痛经）",

    "section4_title": "电针针灸的注意事项",
    "precaution1": "治疗前咨询：电针针灸不适合所有人，特别是对于一些有严重心脏病、皮肤病或者孕妇等特定人群，使用前应咨询专业的针灸医生。",
    "precaution2": "治疗过程中感受：一些患者在电流刺激下可能会感到轻微的麻刺感或电流感，这是正常的反应。如果感到不适，应及时告知医生调节电流强度。",
    "precaution3": "避免过度使用：虽然电针针灸有较好的治疗效果，但如果频繁使用或强度过大，可能会对皮肤和组织产生不良影响。"
  }
};
